export default {
    day: '2023-09-29',
    content: {
        school: [
            {
                type: 'balance',
                text: '42',
                balance: 'buff',
                before: '+15%',
                after: '+35%',
            },
            {
                type: 'bugfix',
                text: '43',
            },
            {
                type: 'remove',
                text: '44',
            }
        ],
    }
}
